export class AuditData {
    constructor(
        public remoteAddress: string,
        public sessionId: string,
        public accessId: string,
        public hebergementId: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/audits/audit-data.model.ts